<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Leave Request Form
              <div class="card-header-actions">
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>
            <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Employee</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewinfo" readonly :state="!$v.model.crewkey.$error"></b-form-input>
                        <b-input-group-append v-if="(this.leaveclaimMenu!='hrm.leaveclaimself')">
                        <b-btn text="Button" @click="lkuCrewShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Job Title</label></b-input-group-prepend>
                      <b-form-input v-model="model.jabatan" placeholder="Job Title" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                        <b-form-input v-model="model.departemen" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Location</label></b-input-group-prepend>
                        <b-form-input v-model="model.location" disabled></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Project</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.projectname" ></b-form-input>
                    </b-input-group>

                    <b-input-group >
                      <b-input-group-prepend><label>Claim Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.TakenDate" type='date' :state="!$v.model.TakenDate.$error"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Claim No.</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.nomor"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-textarea v-model="model.TakenReason" :state="!$v.model.TakenReason.$error" rows="2" max-rows="4"></b-form-textarea>
                    </b-input-group>
                  <b-input-group>
                      <b-input-group-prepend><label>Leave Taken</label></b-input-group-prepend>
                      <b-form-input v-model="model.TakenDays" type='number' placeholder="Jml hari cuti" :state="!$v.model.TakenDays.$error"></b-form-input>
                      <b-input-group-prepend><span class="input-group-text" style="width:70px;">Days</span> </b-input-group-prepend>
                      <b-form-input v-model="model.TakenDayDesc" placeholder="tgl-tgl hari cuti" :state="!$v.model.TakenDayDesc.$error" style="width:55% !important;"></b-form-input>
                  </b-input-group>      
                  <b-input-group >
                    <b-input-group-prepend><label>Job Delegate To</label></b-input-group-prepend>
                    <b-form-input v-model="model.delegateTo" placeholder="Delegasi tugas saat cuti" ></b-form-input>
                  </b-input-group>

                  <b-row>
                    <b-col cols="7">
                      <b-input-group>
                          <b-input-group-prepend><label>Leave Name</label></b-input-group-prepend>
                          <b-form-input v-model="model.namahakcuti" readonly  :state="!$v.model.namahakcuti.$error"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuLeaveShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                      </b-input-group>                  
                    </b-col>
                    <b-col cols="5">
                        <b-form-radio-group  v-model="model.sesuaiHak" name="radioPayMethod" class="mt-1" disabled>
                            <b-form-radio :value="1">With Entitlement</b-form-radio>
                            <b-form-radio :value="0">No Entitlement</b-form-radio>
                        </b-form-radio-group>
                    </b-col>
                  </b-row>   

                </b-col>
                <b-col lg="6">
                  <h4>Leave Entitlement Allocation (Alokasi Hak Cuti) </h4>
                  <div class="report-wraper">
                    <table style="width: 99%;">
                        <thead>
                            <tr>
                                <th width="20px">No.</th>
                                <th>Claim Periode</th>
                                <th>Claim Expired</th>
                                <th>Balance</th>
                                <th width="150px">Taken/Settled</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in dealLines.items" :key="idx">
                                <td>{{idx+1}}</td>
                                <td>{{row.Berlaku}}</td>
                                <td v-if="(row.expireDate)">{{row.expireDate | moment('YYYY-MMM-DD')}}</td>
                                <td v-else></td>
                                <td>{{row.LeaveBlc | numFormat}} days</td>
                                <td style="text-align:center;">
                                    <b-input-group>
                                        <b-form-input v-model="row.TakenDays"  type="number" :min="0" ></b-form-input>
                                    </b-input-group>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                  </div>                  
                </b-col>
            </b-row>
            <hr>
            <b-row class="justify-content-center">
                        <button  v-if="saveEnabled" class="btn btn-primary ml-2 mr-1" @click.stop="save()"><i class="fa fa-save"></i> Save</button>
                        <b-button class="btn btn-primary mr-2" @click.stop="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew"></lku-crew>
        </b-modal>        
      <b-modal v-model="lkuLeaveShow" size="lg" :hide-footer="true" title="List of Employee Leave" :centered="true" :lazy="true">
          <lku-leave @click="onSelectLkuLeave" ></lku-leave>
      </b-modal>        
        <b-modal v-model="lkuLeaveenttlShow" size="lg" :hide-footer="true" title="List of Leave Entitlemnet" :centered="true" :key="model.crewkey">
            <lku-leaveenttl @click="onSelectLkuLeaveenttl" :crewkey="model.crewkey" :crewname="model.crewname" :LeaveID="model.LeaveID" :namahakcuti="model.namahakcuti" :formdata="lkuLeaveenttlData"></lku-leaveenttl>
        </b-modal>    

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group {
            padding-bottom:2px;
            .input-group-prepend {
                label {
                    padding-top: 5px;
                    padding-right: 5px;
                    width: 90px;
                }
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from 'moment';
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
import leaveclaim from "../../apis/leaveclaim";
import lkuCrew from "../lookup/lkuCrew";
import lkuLeave from '../lookup/lkuLeave';
import lkuLeaveenttl from '../lookup/lkuLeaveenttl';
import toastr from "mini-toastr";
toastr.init();

export default {   
  components:{Loading,myNumber,lkuCrew, lkuLeave,lkuLeaveenttl},
  mixins: [validationMixin],
  validations: {
        model: {
            crewkey: { required },
            TakenDate: {required },
            TakenReason: { required },
            namahakcuti: { required },
            sesuaiHak: { required },
            TakenDays: { required },
            TakenDayDesc: { required },
        },
  }, 
  data () {
    return {
        isLoading:false,
        leaveclaimMenu:'',
        user: this.$store.state.user,
        saveEnabled:true,
        model:{crewkey: '',TakenDate:'',rekapfix:0, TakenDays:1, TakenDayDesc:'',LeaveID: '',TakenReason: '', sesuaiHak:1 },
        lkuCrewShow:false,
        lkuLeaveShow:false,
        lkuLeaveenttlShow:false,
        lkuLeaveenttlData:{},
        currency:[{value:'IDR',text:'IDR'}],
        dealLines: {
            items: [],
            total: 0,
            rekapfix:0,
        },
    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
      LeaveID() {
        return this.model.LeaveID;
      },
      crewkey() {
        return this.model.crewkey;
      }
  },
  watch:{
      LeaveID: function(newval) {
        if (this.crewkey){
          if ((this.dealLines.items.length==0) || ((this.dealLines.items[0].crewkey!==this.crewkey) || (this.dealLines.items[0].LeaveID!==newval))) {
             this.getEntitlement({crewkey:this.crewkey, LeaveID: newval, page:1, limit:1000, sortBy:'Berlaku', outstand:1});
          }
        }
      },
      crewkey: function(newval) {
        if (this.LeaveID){
          if ((this.dealLines.items.length==0) || ((this.dealLines.items[0].crewkey!==newval) || (this.dealLines.items[0].LeaveID!==this.LeaveID))) {
           this.getEntitlement({crewkey:newval, LeaveID: this.LeaveID, page:1, limit:1000, sortBy:'Berlaku', outstand:1});
          }
        }
      }
  },
  created: async function(){
      this.leaveclaimMenu = localStorage.getItem('leaveclaimMenu');
      if (this.$route.params.LeaveTakenID)  {
          toastr.info('Loading Leave Detail, please wait')
          try {
            const data = await leaveclaim.detail(this.$route.params) ;
            this.dealLines.items = data[1];
            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
        this.model.TakenDate=moment(row.TakenDate).format('YYYY-MM-DD');
          this.model.LeaveBlc = (this.model.LeaveBlc || 0) + this.model.TakenDays; 
          console.log('this.dealLines.items : ', this.dealLines.items);
            // this.$forceUpdate();

            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "Error Info",10000);                              
          }
      } else {
        this.model.TakenDate=moment().format('YYYY-MM-DD');
        if (this.leaveclaimMenu=='hrm.leaveclaimself') {
          this.model.crewinfo = this.user.full_name.trim() + ' | ' + this.user.crewnik;
          this.model.crewkey=this.user.crewkey;
          this.model.crewname=this.user.full_name;
          this.model.crewnik=this.user.crewnik;
          this.model.jabatan=this.user.jabatan;
          this.model.departemen=this.user.departemen;
        }

      }
  },
  methods:{
    onSelectLkuCrew: async function (_selected) {
        this.model.crewinfo = _selected.crewname.trim() + ' | ' + _selected.crewnik.trim();
            for (var key in _selected) {
                this.model[key] = _selected[key];
            }        
        this.lkuCrewShow=false;
    },
    onSelectLkuLeave: function(_selected){
        this.model.LeaveID =_selected.LeaveID;
        this.model.namahakcuti =_selected.LeaveNM;
        this.lkuLeaveShow=false;
    },    
    onSelectLkuLeaveenttl(invLookup) {
        this.model.LeaveEnttlId=invLookup.selected.LeaveEnttlId;
        this.model.Periode=invLookup.selected.Periode;
        this.model.LeaveID=invLookup.selected.LeaveID;
        this.model.namahakcuti=invLookup.selected.LeaveNM;
        this.model.Berlaku= invLookup.selected.Berlaku;
        this.model.crewkey=invLookup.selected.crewkey;
        this.model.crewinfo=invLookup.selected.crewinfo;
        this.model.crewname=invLookup.selected.crewname;
        this.model.crewnik=invLookup.selected.crewnik;
        this.model.LeaveBlc=invLookup.selected.LeaveBlc;
        this.model.TakenTtl=invLookup.selected.TakenTtl;
        this.model.LeaveTotal=invLookup.selected.LeaveTotal;
        this.lkuLeaveenttlShow=false;
        this.lkuLeaveenttlData=invLookup;
    },    
    getEntitlement: async function(obj) {
      obj.sortDir = obj.sortDesc ? "desc" : "asc";
      const list = await leaveclaim.entitlement(obj);      
      if (list.length>0) {
        this.model.sesuaiHak=1
      } else {
        this.model.sesuaiHak=0
      }
      this.dealLines.items=list;
          console.log('this.dealLines.items2 : ', this.dealLines.items);

      this.$forceUpdate();
    },    
    calcTotal: function() {
        // this.dealLines.total=this.dealLines.items.length;
        this.model.rekapfix = this.dealLines.items.reduce((a, b) => a + parseInt(b.TakenDays), 0);
    },
    save: async function(){
        this.isLoading=true;
        this.calcTotal();
        if (this.invalidModel) {
            console.log('validation  : ', this.$v.model);
            console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "Error Info");
            this.isLoading=false;
       } else if ((this.model.sesuaiHak==1) && (parseInt(this.model.TakenDays,0) !== this.model.rekapfix)) {
         console.log([this.model.TakenDays,this.model.rekapfix]);
          this.isLoading=false;
          toastr.error('Leave [Taken Days] not balance with [Entitlement Allocation] ', "Error Info");

       } else {
            try {
              const data={};
              data.leaveclaimMenu=this.leaveclaimMenu;
              for (var key in this.model) {
                  data[key] = this.model[key];
              }     
              data.TakenDate = moment(this.model.TakenDate).format('YYYY-MM-DD');

              let newDealLines = this.dealLines.items.reduce((newArr, item) => {
                  if ((item.TakenDays>0) ) {
                      // item.trxDate = moment(item.tanggal).format('YYYY-MM-DD');
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              // this.dealLines.items=newDealLines;
              console.log('newDealLines ', newDealLines);

              data.lines = newDealLines;
              const hasil= await leaveclaim.save(data);
              this.isLoading=false;
              toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Request",10000);
              this.close();
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },
    close(){
      if (this.leaveclaimMenu=='hrm.leaveclaimself')  router.push({name: 'hrm.leaveclaimself'});
      else  router.push({name: 'hrm.leaveclaim'});

    },    
  }
}
</script>